<template>
  <div
    id="notification-list"
    class="d-theme-border-grey-light rounded relative"
  >
    <vs-sidebar
      class="items-no-padding"
      parent="#notification-list"
      :click-not-close="clickNotClose"
      :hidden-background="clickNotClose"
      v-model="isNotificationSidebarActive"
    >
      <notification-sidebar
        :categories="categories"
        @closeSidebar="toggleNotificationSidebar"
      />
    </vs-sidebar>

    <div
      :class="{ 'sidebar-spacer': clickNotClose }"
      class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
    >
      <div
        class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light"
      >
        <!-- TOGGLE SIDEBAR BUTTON -->
        <feather-icon
          class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer"
          icon="MenuIcon"
          @click.stop="toggleNotificationSidebar(true)"
        />

        <!-- SEARCH BAR -->
        <vs-input
          icon-no-border
          size="large"
          icon-pack="feather"
          icon="icon-search"
          placeholder="検索キーワード"
          v-model="searchQuery"
          class="vs-input-no-border vs-input-no-shdow-focus w-full"
        />
      </div>

      <div
        class="notification-list__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light"
      >
        <div class="flex items-center">
          <feather-icon icon="BellIcon"></feather-icon>
          <span class="ml-2">通知履歴</span>
        </div>
        <div class="flex">
          <vs-button
            v-if="hasUnread"
            size="small"
            color="primary"
            type="border"
            @click="onReadeAllNotifications"
            >すべて既読にする</vs-button
          >
        </div>
      </div>

      <component
        :is="scrollbarTag"
        class="notification-list-content-scroll-area"
        :settings="settings"
        ref="mailListPS"
        :key="$vs.rtl"
      >
        <transition-group
          name="list-enter-up"
          class="notification-list__notifications"
          tag="ul"
          appear
        >
          <li
            class="cursor-pointer notification-list__notification-item"
            v-for="(notification, index) in notifications"
            :key="String(notification.id)"
            @click="updateOpenNotificationId(notification.id)"
            :style="{ transitionDelay: index * 0.1 + 's' }"
          >
            <notification-item
              :notification="notification"
              :category="categories"
            />
          </li>
        </transition-group>
      </component>
    </div>

    <notification-view
      :openNotificationId="openNotificationId"
      :isSidebarActive="isSidebarActive"
      @closeSidebar="closeNotificationViewSidebar"
    >
    </notification-view>
  </div>
</template>

<script>
import NotificationSidebar from "./NotificationSidebar.vue";
import NotificationItem from "./NotificationItem.vue";
import NotificationView from "./NotificationView.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState, mapGetters } = createNamespacedHelpers(
  "notification"
);

export default {
  components: {
    NotificationItem,
    NotificationSidebar,
    NotificationView,
    VuePerfectScrollbar
  },
  data() {
    return {
      openMailId: null,
      openNotificationId: null,
      selectedMails: [],
      isSidebarActive: false,
      showThread: false,
      clickNotClose: true,
      isNotificationSidebarActive: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      }
    };
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false;
    },
    windowWidth() {
      this.setSidebarWidth();
    }
  },
  computed: {
    ...mapState({
      notificationSearchQuery: state => state.notificationSearchQuery,
      notificationFilter: state => state.notificationFilter,
      categories: state => state.categories
    }),
    ...mapGetters(["filteredNotification", "hasUnread"]),
    searchQuery: {
      get() {
        return this.notificationSearchQuery;
      },
      set(val) {
        this.setNotificationSearchQuery(val);
      }
    },
    notifications() {
      return this.filteredNotification;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    ...mapActions([
      "fetchAllNotifications",
      "fetchUnreadNotifications",
      "setNotificationSearchQuery",
      "readeAllNotifications"
    ]),
    updateOpenNotificationId(notificationIdId) {
      this.openNotificationId = notificationIdId;
      this.isSidebarActive = true;
    },
    closeNotificationViewSidebar() {
      this.isSidebarActive = false;
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isNotificationSidebarActive = this.clickNotClose = false;
      } else {
        this.isNotificationSidebarActive = this.clickNotClose = true;
      }
    },
    toggleNotificationSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar();
        if (this.clickNotClose) {
          return;
        }
      }
      this.isNotificationSidebarActive = value;
    },
    async onReadeAllNotifications() {
      this.$vs.loading();
      try {
        await this.readeAllNotifications();
        await this.fetchUnreadNotifications();
        await this.fetchAllNotifications();
        this.$vs.loading.close();
        this.$vs.notify({
          title: "すべてのお知らせを既読にしました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "既読処理に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    }
  },
  async created() {
    await this.fetchAllNotifications();
    if (this.$route.query.notificationId) {
      this.updateOpenNotificationId(this.$route.query.notificationId);
    }
  },
  mounted(){
    let routerViewElement = document.getElementsByClassName('router-view')
    routerViewElement[0].style.padding = "2.2rem"
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/notification-list.scss";
</style>
